<template>
  <div v-if="!route.query.deal" class="mt-10 justify-center mx-3" align="center">
    <v-card class="pa-10 text-primary rounded-lg" style="max-width: 500px">
      <h1>{{ t("onboarding.landing.noDealTitle") }}</h1>
      <p class="mt-5">
        {{ t("onboarding.landing.noDealDescription", { email: "help@yetipay.me" }) }}
      </p>
    </v-card>
  </div>

  <div v-else-if="hasLoaded" class="on-secondary" align="center">
    <h1 class="d-flex justify-center">
      {{ t("onboarding.landing.welcomeTitle") }}
    </h1>
    <p class="d-flex justify-center">
      {{ t("onboarding.landing.welcomeDescription") }}
    </p>
    <p class="d-flex justify-center mt-15">
      <v-btn-var @click="navigateToWizard">
        {{ t("onboarding.landing.startButton") }}
      </v-btn-var>
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import { useAuthenticationStore } from "@/store/authentication";
import { useMerchantsStore } from "@/store/merchants";

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const merchantsStore = useMerchantsStore();
const authStore = useAuthenticationStore();

onBeforeRouteUpdate((to, from, next) => {
  if (merchantsStore.currentMerchant && !merchantsStore.isCurrentMerchantVerified) {
    next("/onboarding/wizard");
  }
});

const hasLoaded = ref(false);
onMounted(() => {
  const partialRequest = localStorage.getItem(`${authStore.user.email}:partialMerchantRequest`);
  if (partialRequest && !!route.query.deal) {
    navigateToWizard();
  } else {
    hasLoaded.value = true;
  }
});

const navigateToWizard = () =>
  router.push("/onboarding/wizard" + route.fullPath.replace(route.path, "")); // preserve query params;
</script>
